import { Dependencies } from '../dependencies';
import { usePublicationCriteriaFilter } from './usePublicationCriteriaFilter';
import { usePublicationDateFilter } from './usePublicationDateFilter';
import { usePublicationRecentFilter } from './usePublicationRecentFilter';
import { usePublicationTypeFilter } from './usePublicationTypeFilter';

export const publicationFiltersDependencies = new Dependencies('publicationFiltersDependencies', [
  usePublicationCriteriaFilter,
  usePublicationDateFilter,
  usePublicationRecentFilter,
  usePublicationTypeFilter,
]);
export const clearPublicationFilters = (...args) => {
  publicationFiltersDependencies.clearDependencies(...args);
};
